import PictureData from './PictureData';

export default PictureData;
